import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Form } from 'react-bootstrap'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'
import { useStateValue } from '@State'
import { ltiOrgKeyManagement as endpoints } from '@URLS'

export const NewContextModal = props => {
  const [currentState, dispatch] = useStateValue()

  const [newContextId, updateNewContextId] = useState('')
  const [newContextTitle, updateNewContextTitle] = useState('')
  const [lmsCourseId, updateLmsCourseId] = useState('')

  const handleContextIdChange = e => {
    updateNewContextId(e.target.value)
  }

  const handleContextTitleChange = e => {
    updateNewContextTitle(e.target.value)
  }

  const handleLmsCourseIdChange = e => {
    updateLmsCourseId(e.target.value)
  }

  const AddNewContext = () => {
    try {
      client.post(endpoints.addNewContext({ orgId: props.orgId }), {
        contextId: newContextId,
        contextTitle: newContextTitle,
        lmsCourseId: lmsCourseId,
      })
      toast.success("Successfully added new context.")
      // Trigger the lower components useEffect hook
      dispatch({ type: 'reload', reload: !currentState.reloadSwitch })
    } catch (err) {
      console.log(err)
      toast.error("There was an error trying to create a new context.")
    } finally {
      props.toggle(!props.show)
    }
  }

  return (
    <Modal show={props.show} onHide={() => props.toggle(!props.show)}>
      <Modal.Header closeButton>
        <Modal.Title>New Context</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="contextId">
          <Form.Label>New Context Id</Form.Label>
          <Form.Control
            type="text"
            onChange={handleContextIdChange}
            value={newContextId}
          />
        </Form.Group>
        <Form.Group controlId="contextTitle">
          <Form.Label>New Context Title</Form.Label>
          <Form.Control
            type="text"
            onChange={handleContextTitleChange}
            value={newContextTitle}
          />
        </Form.Group>
        <Form.Group controlId="lmsCourse">
          <Form.Label>LMS Course ID</Form.Label>
          <Form.Control
            type="text"
            onChange={handleLmsCourseIdChange}
            value={lmsCourseId}
          />
        </Form.Group>
        <div
          className="btn btn-success btn-myed btn-success-myed"
          onClick={() => AddNewContext()}
        >
          <div className="fa-regular fa-plus fa-fw mr-2" /> Add Context
        </div>
      </Modal.Body>
    </Modal>
  )
}

NewContextModal.propTypes = {
  orgId: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}
